import React from 'react';
import { observer } from 'mobx-react-lite';

const SaddleHeight = observer(({ saddleHeight }) => {
  if (!saddleHeight) return null;

  return (
    <tr>
      <td className="pale">Седельное устр-во.</td>
      <td>{saddleHeight} мм</td>
    </tr>
  );
});

export default SaddleHeight;
